import colors from './colors'

const getColor = (status) => {
  switch (status) {
    case 'cancelled':
    case 'PUPIL_CANCELLED':
    case 'TUTOR_CANCELLED':
      return colors.error
    case 'confirmed':
    case 'CONFIRMED':
      return colors.button_blue
    case 'ordered':
    case 'ORDERED':
      return colors.orange
    case 'done':
    case 'COMPLETED':
      return colors.validated
    case 'assigned':
      return colors.orange
    default:
      return 'black'
  }
}

export {
  getColor,
}
